import { bookingStatus } from 'utils/constants/booking-constants'
import DataItemStatus from 'components/molecules/DataItemStatus'
import React from 'react'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import _ from 'lodash'

const EmployeeStatusTag = ({ employee, employeeStatus }) => {
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	let status = _.has( employeeStatus, employee?.guid ) ? employeeStatus[ employee.guid ] : bookingStatus.INVITED;
	if( employee?.guid === _employee?.guid ) {
		status = bookingStatus.INVITE_ACCEPTED
	}
	
	return (
		<DataItemStatus>
			{ status }
		</DataItemStatus>
	)
}

export default EmployeeStatusTag
